import { render, staticRenderFns } from "./MaterialModal.vue?vue&type=template&id=5f02f53c&scoped=true"
import script from "./MaterialModal.vue?vue&type=script&lang=js"
export * from "./MaterialModal.vue?vue&type=script&lang=js"
import style0 from "./MaterialModal.vue?vue&type=style&index=0&id=5f02f53c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f02f53c",
  null
  
)

export default component.exports